import {fetchIssueTypes} from '@github-ui/item-picker-issue-type-tsq'
import {useQuery, useQueryClient} from '@github-ui/react-query'

const ISSUE_TYPES_LIMIT = 25

export function useIssueTypesQuery({owner, repo}: {owner: string | undefined; repo: string | undefined}) {
  const queryClient = useQueryClient()
  const queryKey = ['copilot-immersive-issue-types', JSON.stringify(queryClient), owner, repo]

  const queryFn = async () => {
    if (!owner || !repo) return []

    // TSQ implementation uses an empty query to fetch all issue types for the repository
    const response = await fetchIssueTypes(queryClient, {
      owner,
      repo,
      query: '',
      count: ISSUE_TYPES_LIMIT,
    })
    return response.issueTypes
  }

  return useQuery({
    queryKey,
    queryFn,
  })
}
